import { app } from '../../app.module'
interface IBrand {
  brandId: number
  brandName: string
  brandCategoryName: string
  brandSubCategoryName: string
  totalFollowers: number
  fbAccounts: any[]
  twAccounts: any[]
  inAccounts: any[]
  ytAccounts: any[]
  lineAccounts: any[]
  ttAccounts: any[]
}

/**
 * CsvダウンロードBrandサービス
 */
export class CsvDownloadBrand {
  constructor(
    private $rootScope: any,
    private $q: ng.IQService,
    private $filter: any
  ) {}

  public download(
    brands: IBrand[],
    order: string,
    filter: {
      categoryName: string
      subCategoryName: string
      keywordFilter: string
    }
  ) {
    const deferred = this.$q.defer()
    const csvData = []
    const dataHeader = ['No', 'ブランド名', '総フォロワー数']
    if (this.$rootScope.flgFacebook === true) {
      dataHeader.push('Facebookフォロワー数', 'Facebookアカウント数')
    }
    if (this.$rootScope.flgTwitter === true) {
      dataHeader.push('Twitterフォロワー数', 'Twitterアカウント数')
    }
    if (this.$rootScope.flgInstagram === true) {
      dataHeader.push('Instagramフォロワー数', 'Instagramアカウント数')
    }
    if (this.$rootScope.flgYoutube === true) {
      dataHeader.push('Youtubeフォロワー数', 'Youtubeアカウント数')
    }
    if (this.$rootScope.flgLine === true) {
      dataHeader.push('Lineフォロワー数', 'Lineアカウント数')
    }
    if (this.$rootScope.flgTiktok === true) {
      dataHeader.push('TikTokフォロワー数', 'TikTokアカウント数')
    }

    csvData.push(dataHeader)

    brands = this.$filter('orderBy')(brands, order, 'desc')

    let csvNo = 1

    for (let index = 0; index < brands.length; index = index + 1) {
      const brand = brands[index]
      // filter
      if (
        filter.categoryName !== null &&
        filter.categoryName !== '指定しない' &&
        filter.categoryName !== brand.brandCategoryName
      ) {
        continue
      }
      if (
        filter.subCategoryName !== null &&
        filter.subCategoryName !== '指定しない' &&
        filter.subCategoryName !== brand.brandSubCategoryName
      ) {
        continue
      }
      if (
        filter.keywordFilter !== null &&
        brand.brandName.match(
          new RegExp(filter.keywordFilter.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i')
        ) === null
      ) {
        continue
      }

      // CSV列データ
      const csvRow = [csvNo, brand.brandName, brand.totalFollowers]

      // Facebookデータを格納
      if (this.$rootScope.flgFacebook === true) {
        let fbFollowers = 0
        for (let i = 0; i < brand.fbAccounts.length; i = i + 1) {
          fbFollowers += brand.fbAccounts[i].followers
        }
        csvRow.push(fbFollowers, brand.fbAccounts.length)
      }

      // Twitterデータを格納
      if (this.$rootScope.flgTwitter === true) {
        let twFollowers = 0
        for (let i = 0; i < brand.twAccounts.length; i = i + 1) {
          twFollowers += brand.twAccounts[i].followers
        }
        csvRow.push(twFollowers, brand.twAccounts.length)
      }

      // Instagramデータを格納
      if (this.$rootScope.flgInstagram === true) {
        let inFollowers = 0
        for (let i = 0; i < brand.inAccounts.length; i = i + 1) {
          inFollowers += brand.inAccounts[i].followers
        }
        csvRow.push(inFollowers, brand.inAccounts.length)
      }

      // Youtubeデータを格納
      if (this.$rootScope.flgYoutube === true) {
        let ytFollowers = 0
        for (let i = 0; i < brand.ytAccounts.length; i = i + 1) {
          ytFollowers += brand.ytAccounts[i].followers
        }
        csvRow.push(ytFollowers, brand.ytAccounts.length)
      }

      // Lineデータを格納
      if (this.$rootScope.flgLine === true) {
        let lineFollowers = 0
        for (let i = 0; i < brand.lineAccounts.length; i = i + 1) {
          lineFollowers += brand.lineAccounts[i].followers
        }
        csvRow.push(lineFollowers, brand.lineAccounts.length)
      }

      // TikTokデータを格納
      if (this.$rootScope.flgTiktok === true) {
        const ttFollowers = brand.ttAccounts.reduce(
          (total, account) => total + account.followers,
          0
        )

        csvRow.push(ttFollowers, brand.ttAccounts.length)
      }

      // CSVデータを格納
      csvData.push(csvRow)

      csvNo = csvNo + 1
    }

    deferred.resolve(csvData)

    return deferred.promise
  }
}

// CSVダウンロード用のサービスを定義
app.service('CsvDownloadBrand', CsvDownloadBrand)
